module.exports = __webpack_public_path__ + "img/co-branding-world-RP-1.b8d5aca1.gif";